
















import { Component, Vue } from 'vue-property-decorator';
import Teacher from '@/services/Teacher';
import Roles from '@/services/Roles';

@Component
export default class AdminMenu extends Vue {
  teacherId: string | null = null;

  async mounted() {
    this.teacherId = this.$route.params.id;
  }
}
